var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermissionPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 100",
    d: "M18.5212 9C18.5212 13.8332 14.6157 17.75 9.79965 17.75C4.98363 17.75 1.07812 13.8332 1.07812 9C1.07812 4.16676 4.98363 0.25 9.79965 0.25C14.6157 0.25 18.5212 4.16676 18.5212 9Z",
    fill: "#FF5630",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Orange"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 38764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 120",
    d: "M5.63497 12.9614L4.54818 7.86647C4.53125 7.78707 4.61098 7.72165 4.68554 7.75377L7.68713 9.04666C7.73558 9.06753 7.79191 9.04718 7.81582 9.00016L9.7887 5.12166C9.82441 5.05146 9.92347 5.04817 9.96376 5.11584L12.2783 9.00338C12.3052 9.04862 12.3626 9.06523 12.4096 9.04135L14.9094 7.76972C14.9835 7.73203 15.0686 7.79596 15.053 7.87762L14.0818 12.9593C14.0728 13.0064 14.0316 13.0405 13.9836 13.0405H5.73277C5.68559 13.0405 5.64482 13.0075 5.63497 12.9614Z",
    fill: "#FFA4A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 121",
    d: "M5.63497 12.9609L4.54829 7.86651C4.53133 7.78702 4.61126 7.72158 4.68585 7.7539L7.01053 8.76113C7.04005 8.77392 7.06161 8.80012 7.06847 8.83155L7.9612 12.9187C7.97482 12.9811 7.92733 13.04 7.86351 13.04H5.73277C5.68559 13.04 5.64482 13.0071 5.63497 12.9609Z",
    fill: "#FFD6D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 122",
    d: "M5.10259 10.5773L4.54599 7.86295C4.52982 7.78408 4.60873 7.71941 4.68288 7.75075L5.79389 8.22032C5.82368 8.23291 5.84554 8.25912 5.85257 8.29069L6.35267 10.5355C6.36658 10.5979 6.31906 10.6572 6.25506 10.6572H5.20055C5.15306 10.6572 5.11213 10.6238 5.10259 10.5773Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 120_2",
    d: "M5.63497 12.9614L4.54818 7.86647C4.53125 7.78707 4.61098 7.72165 4.68554 7.75377L7.68713 9.04666C7.73558 9.06753 7.79191 9.04718 7.81582 9.00016L9.7887 5.12166C9.82441 5.05146 9.92347 5.04817 9.96376 5.11584L12.2783 9.00338C12.3052 9.04862 12.3626 9.06523 12.4096 9.04135L14.9094 7.76972C14.9835 7.73203 15.0686 7.79596 15.053 7.87762L14.0818 12.9593C14.0728 13.0064 14.0316 13.0405 13.9836 13.0405H5.73277C5.68559 13.0405 5.64482 13.0075 5.63497 12.9614Z",
    stroke: "black",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionPink);
export default __webpack_public_path__ + "static/media/permissionPink.1d5ad02871cd2964014320f42cc2843d.svg";
export { ForwardRef as ReactComponent };